<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AccountNotifications',
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            optInAccount: null,
            optInMarketing: null,
            optInChangesMade: false,
        }
    },
    methods: {
        async onSaveNotifPrefs() {
            this.userResource.attributes.opt_in_account_updates = this.optInAccount
            this.userResource.attributes.opt_in_marketing_updates = this.optInMarketing
            await this.userResource.save()
            this.optInChangesMade = false
        }
    },
    mounted() {
        this.optInAccount = this.userResource.attributes.opt_in_account_updates
        this.optInMarketing = this.userResource.attributes.opt_in_marketing_updates
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Notificaciones</h4>
            <p class="text-muted mb-0">Controla cómo y cuándo te contactamos.</p>
        </div>
        <b-card>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInAccount" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Actualizaciones de Cuenta</span>
                    <small class="text-muted">
                        Mensajes transaccionales relacionados con tu cuenta, pedidos o servicios que has solicitado, incluyendo recordatorios de citas, confirmaciones de pedidos y notificaciones de cuenta. Pueden aplicarse tarifas de mensajes y datos. Responde AYUDA para obtener ayuda o STOP para cancelar la suscripción.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInMarketing" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Marketing y Promociones</span>
                    <small class="text-muted">
                        Ofertas especiales, descuentos y actualizaciones de nuevos productos. Pueden aplicarse tarifas de mensajes y datos. Responde AYUDA para obtener ayuda o STOP para cancelar la suscripción.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-button variant="primary" :disabled="!optInChangesMade" @click="onSaveNotifPrefs()">Guardar Preferencias</b-button>
        </b-card>
    </div>
</template>
